import types from "./unitNameTypes";

export default (state, action) => {
	switch (action.type) {
		case types.SET_LOADING:
			return {
				...state,
				loading: !state.loading
			};
		case types.SET_UNIT_NAMES:
			return {
				...state,
				loading: false,
				unitNames: action.payload
			};
		default:
			return state;
	}
};